export { apiClient, apiFetch } from "./client";
export {
  API_ENDPOINTS,
  API_ORIGIN,
  API_V1_URL,
  AUTH_V1_URL,
  TRAINER_API_ORIGIN,
  TRAINER_API_V1_URL,
  getApiSourceMeta,
} from "./endpoints";
export type { ApiSourceMeta } from "./endpoints";

